<template>
  <div class="delete-modal instrument-modal-window"
       cy="delete-modal">
    <p class="text-center">
      {{ text }}
    </p>

    <div class="actions-bar text-center">
      <button cy="no"
              @click="handleNo">
        NU
      </button>

      <button cy="yes"
              @click="handleYes">
        DA
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DeleteModal',
    props: {
      text: String
    },
    methods: {
      handleNo () {
        this.$emit('no')
      },
      handleYes () {
        this.$emit('yes')
      }
    }
  }
</script>

<style lang="less">
  .delete-modal {
    @media only screen and (min-width: 0) {
      width: 400px;
      p {
        font-size: 1.8rem;
      }
      .actions {
        margin-top: 24px;
      }
    }
  }
</style>
